import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { getAuth } from 'services/auth.service';
import { getMediaFromCloudFrontUrl, uploadToS3Bucket } from 'services/aws.service';

const ALLOWED_EXTS = ['.pdf'];
const GUIDE_DOCUMENT_S3_KEY = 'users/profile_pictures/docs/DEON_GUIDE.pdf';

function getLowerExt(name = '') {
    const parts = String(name).split('.');
    return parts.length > 1 ? `.${parts.pop().toLowerCase()}` : '';
}

export default function useGuideDocument() {
    const isSuperAdmin = useCallback(() => getAuth()?.role === 'SuperAdmin', []);

    const openGuideDocument = useCallback(async () => {
        const guideUrl = getMediaFromCloudFrontUrl(GUIDE_DOCUMENT_S3_KEY);
        if (!guideUrl) return;
        const sep = guideUrl.includes('?') ? '&' : '?';
        window.open(`${guideUrl}${sep}v=${Date.now()}`, '_blank', 'noopener,noreferrer');
    }, []);

    const uploadGuideDocument = useCallback(async (fileList) => {
        try {
            const file = Array.from(fileList || [])[0];
            if (!file) return;

            const ext = getLowerExt(file?.name);
            if (!ALLOWED_EXTS.includes(ext)) {
                toast('Unsupported file type', { type: 'error' });
                return;
            }

            await uploadToS3Bucket(GUIDE_DOCUMENT_S3_KEY, file);
            toast('Guide uploaded successfully', { type: 'success' });
        } catch (err) {
            toast('Failed to upload guide', { type: 'error' });
        }
    }, []);

    return { isSuperAdmin, openGuideDocument, uploadGuideDocument };
}

